// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.self_diagnosis_mng .d2-container-full__header{\r\n    background: transparent !important;\r\n    padding: 0 !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
